export default {
  get: () => {
    return import.meta.env.VITE_COUNTRY
  },
  is: country => {
    return import.meta.env.VITE_COUNTRY === country
  },
  isNot: country => {
    return import.meta.env.VITE_COUNTRY !== country
  }
}
